import styled from "styled-components"

export const ComposeFaxStyle = styled.div`
  height: calc(100vh - 120px);
  padding: 24px;
  border-radius: 8px;
  background: ${(props) => props.theme.colordwhitedark};
  display: flex;
  flex-direction: column;
  overflow: auto;
  @media (min-width: 0px) and (max-width: 1081px) {
    height: auto;
    padding: 15px;
  }
  .compose-fax {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    .ant-row {
      flex: 1;
    }
    .preview-wrapper {
      padding-left: 24px;
      margin-left: 24px;
      border-left: 1px solid ${(props) => props.theme.colorbluegreylight};
      height: calc(100vh - 310px);
      overflow: auto;
      @media (min-width: 0px) and (max-width: 1081px) {
        height: auto;
        padding-left: 0;
        margin-left: 0;
        border-left: none;
      }
      .no-preview-wrapper {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px;
        background: ${(props) => props.theme.testblock};
        border: 1px solid ${(props) => props.theme.colorbluegreylight};
        border-radius: 8px;
        font-size: 20px;
        opacity: 0.5;
      }
      .preview-action {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 15px;
        gap: 8px;
        .font-icon {
          font-size: 14px;
          color: ${(props) => props.theme.colorlightblack};
          border: 1px solid ${(props) => props.theme.textcolorlightgrey};
          border-radius: 4px;
          background: transparent;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          &.disabled {
            cursor: not-allowed;
            opacity: 0.5;
          }
        }
      }
    }
    .compose-fax-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid ${(props) => props.theme.colorbluegreylight};
      padding-bottom: 15px;
      margin-bottom: 30px;
      color: ${(props) => props.theme.textcolordblack};
      &__right {
        display: flex;
        align-items: center;
        .form-group {
          display: flex;
          align-items: center;
        }
        label {
          font-weight: 400;
          font-size: 14px;
          margin-right: 15px;
          color: ${(props) => props.theme.textcolordblack};
        }
      }
    }
    .compose-fax-content {
      height: calc(100vh - 310px);
      overflow-y: auto;
      overflow-x: hidden;
      @media (min-width: 0px) and (max-width: 1081px) {
        height: auto;
        overflow: unset;
      }
      .form-action {
        padding-top: 36px;
        gap: 10px;
        .delete-recipient-icon {
          color: ${(props) => props.theme.colordanger};
        }
        .ant-btn {
          width: auto;
        }
      }
      > .form-group {
        border-bottom: 1px solid ${(props) => props.theme.colorbluegreylight};
        &.upload {
          border-bottom: none;
        }
        &.shadow-wrap {
          padding-bottom: 24px;
        }
        .shadow {
          padding: 15px;
          background: ${(props) => props.theme.testblock};
          border: 1px solid ${(props) => props.theme.colorbluegreylight};
          border-radius: 8px;
          label {
            font-size: 12px;
          }
          .add-more-action {
            margin-top: 10px;
            > span {
              display: flex;
              align-items: center;
            }
          }
        }
      }
      .upload-wrapper {
        marginb-bottom: 20px;
        .upload-head {
          font-size: 14px;
          color: ${(props) => props.theme.textcolordblack};
          margin-bottom: 6px;
        }
        .upload-details {
          font-size: 12px;
          color: ${(props) => props.theme.textcolordblack};
          margin-bottom: 12px;
          display: inline-block;
          color: ${(props) => props.theme.textcolordarkgrey};
          max-width: 443px;
        }
        .ant-upload-list-item-name {
          font-size: 12px;
          color: ${(props) => props.theme.textcolordarkgrey};
        }
      }
      .form-label {
        font-size: 14px;
        color: ${(props) => props.theme.textcolordblack};
        font-weight: 600;
        margin-bottom: 5px;
      }
      .checkbox-wrapper {
        margin-top: 20px;
      }
      .radio-wrapper {
        margin-top: 20px;
        margin-bottom: 20px;
      }
      .error-msg {
        font-size: 12px;
        color: ${(props) => props.theme.colorlightgrey};
        margin-top: 5px;
        &.warning {
          font-size: 12px;
          color: ${(props) => props.theme.colordanger};
        }
      }
      .max-w-850 {
        max-width: 850px;
      }
      .infoicon {
        font-size: 18px;
        color: ${(props) => props.theme.primary};
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
      }
      .csv-wrapper {
        display: flex;
        align-items: center;
        color: ${(props) => props.theme.textcolordblack};
        font-size: 14px;

        .ant-upload {
          margin: 0 15px;
        }
      }
      .form-group {
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;
        padding-bottom: 15px;
        .ant-tag {
          font-size: 14px;
          border-radius: 5px;
          padding: 5px;
        }
        .form-group {
          padding-bottom: 0;
          margin-bottom: 0;
        }
        .option-btn {
          position: absolute;
          top: 35px;
          right: 30px;
          .linkstyle {
            font-size: 11px;
          }
        }
        .ant-picker-suffix {
          font-size: 14px;
          color: ${(props) => props.theme.colorbluegrey};
        }
        textarea {
          &.ant-input {
            background-color: transparent;
          }
        }
        .ant-select {
          &.optional {
            margin-top: 10px;
          }
        }
        .ant-form-item {
          margin-bottom: 0;
        }
        &.row {
          flex-direction: row;
          align-items: center;
          label {
            margin-bottom: 0;
            &.info-tool {
              margin: 0;
              margin-right: 5px;
            }
          }
        }
        label {
          font-size: 14px;
          height: auto;
          color: ${(props) => props.theme.textcolordblack};
          margin-right: 30px;
          margin-bottom: 4px;
        }
      }
    }
    .compose-fax-footer {
      border-top: 1px solid ${(props) => props.theme.colorbluegreylight};
      padding-top: 24px;
      margin-top: 16px;
      .footerright {
        display: flex;
        justify-content: flex-end;
        .ant-btn {
          &:first-child {
            margin-right: 10px;
          }
        }
      }
    }
  }
  .breadcrumb-wrapper {
    margin-bottom: 24px;
  }
`;
export const ComposeFaxHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  border-bottom: 1px solid ${(props) => props.theme.colorbluegreylight};
  padding-bottom: 20px;
  h5 {
    font-size: 16px;
    margin: 0;
  }
`